export default {
  title: 'light',
  colors: {
    primary: '#3F8EFC',
    secondary: '#3B28CC',
    danger: '#ff0000',
    dark: '#1A1423',
    light: '#ADD7F6',
    background: '#f0f0f0',
    text: '#333',
    input: {
      color: '#333',
      background: '#f0f0f0',
    },
    card: 'rgba(255, 255, 255, 0.75)',
    cardBackground: '#e0e0e0',
  },
};
